import { MYSQL } from 'drapcode-constant';
import { alertMessagesArgsConfig, browserStorageArgsConfig } from '../../utils/event_constants';

export const mysqlActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'MySQL: Send Data To API',
    source: MYSQL,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsMySQL',
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
];
